import { DecisionEnvironment } from "src/api/types";
import { PillToggle } from "src/base-components/PillToggle";
import { SkeletonPlaceholder } from "src/base-components/SkeletonPlaceholder";

export const EnvironmentPillPlaceholder = () => {
  return <SkeletonPlaceholder height="h-5" width="w-32" />;
};

type EnvironmentPillProps = {
  includeTest?: boolean;
  value: DecisionEnvironment;
  onChange: (env: DecisionEnvironment) => void;
};

export const EnvironmentPill: React.FC<EnvironmentPillProps> = ({
  includeTest = false, // only included with powertools feature flag
  value,
  onChange,
}) => {
  return (
    <PillToggle value={value} onChange={onChange}>
      {[
        <PillToggle.Button key="live" value={DecisionEnvironment.LIVE}>
          Live
        </PillToggle.Button>,
        <PillToggle.Button key="sandbox" value={DecisionEnvironment.SANDBOX}>
          Sandbox
        </PillToggle.Button>,
        ...(includeTest
          ? [
              <PillToggle.Button key="test" value="test">
                Test
              </PillToggle.Button>,
            ]
          : []),
      ]}
    </PillToggle>
  );
};
